module.exports = __webpack_public_path__ + "media/safetyindex.7ae873ad.webm";